import { useOrderService } from '../service/order';

export function useOrder() {
  const {
    create,
    calculate,
    exportOrder,
    getById,
    cancelOrder,
    importOrder,
    awbData,
    previewPODOrder,
    ...restOrderService
  } = useOrderService();

  function getOrderById(id: string) {
    return getById(id);
  }

  async function calculateParcelPrice(payload: CalculateParcelPricePayload) {
    const response = await calculate(payload);
    return response;
  }

  async function createOrder(payload: IOrderCreatePayload) {
    const response = await create(payload);
    return response;
  }

  async function handleCancelOrder(payload: CancelOrderPayload) {
    const response = await cancelOrder(payload);
    return response;
  }

  function getAwbData(awb: string) {
    return awbData(awb);
  }

  async function handleImportOrder(file: any) {
    const payload = new FormData();
    payload.append('files', file);

    const response = await importOrder(payload);
    return response;
  }

  async function getPOD(fileName: string) {
    const response = await previewPODOrder(fileName);
    const blobUrl = URL.createObjectURL(response);
    window.open(blobUrl, '_blank');
  }

  async function handleExportOrder(payload: any): Promise<any> {
    return exportOrder(payload);
  }

  return {
    calculateParcelPrice,
    createOrder,
    getOrderById,
    handleCancelOrder,
    getAwbData,
    handleExportOrder,
    handleImportOrder,
    getPOD,
    ...restOrderService,
  };
}

export default useOrder;
